import { IEscalatedPageDetailModel } from "../../Models/escalatedPageModels";
import { GetFormatTitle } from "../../Components/tableComponent/getTableColumn/getFormattedData";
import { AGENT_FIRST_NAME_KEY, AGENT_NAME_LABEL, APPLICANT_FIRST_NAME_KEY, APPLICANT_NAME_LABEL } from "./escalatedPage.constants";

export const getEscalationColumnLabel = (keyName: keyof IEscalatedPageDetailModel) => {
    if (keyName === AGENT_FIRST_NAME_KEY) {
        return AGENT_NAME_LABEL;
    }
    if (keyName === APPLICANT_FIRST_NAME_KEY) {
        return APPLICANT_NAME_LABEL;
    }
    return GetFormatTitle(keyName);
};

export const getCombinedEscalationNameValue = (
    keyName: keyof IEscalatedPageDetailModel,
    row: IEscalatedPageDetailModel
) => {
    if (keyName === AGENT_FIRST_NAME_KEY) {
        const agentName = [row.userFirstName, row.userLastName].filter(Boolean).join(" ").trim() || "-";   
        return agentName;
    }
    if (keyName === APPLICANT_FIRST_NAME_KEY) {
        const applicantName = [row.firstName, row.lastName].filter(Boolean).join(" ").trim() || "-";
        return applicantName;
    }
    return row[keyName]?.toString() ?? "";
};
